if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');
        this.upsellOverlay = document.querySelector('upsell-drawer');

        this.mobileScreenSize = 768; // Set the screen size threshold

        if (theme.settings.afterAtc !== 'no-js') {
          this.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        const error = typeof data.description === 'string' ? data.description : data.message;

        function onDrawerOpen() {
          // updateDiscountValues(); // undefined function
          const drawerContent = document.querySelector('.drawer__content'); 
          const observer = new MutationObserver(() => {
            // updateDiscountValues(); // undefined function
          });
          observer.observe(drawerContent, { childList: true, subtree: true });
          appendQuantityDiscount();
        }

        document.querySelector('.drawer').addEventListener('transitionend', onDrawerOpen);

        if (data.status) this.setErrorMsgState(error);

        if (error !='La quantité demandée est indisponible') {
          if (!response.ok) throw new Error(response.status);
        } else {
          cartItems.refresh();
        }

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {

              const isMobile = window.innerWidth < this.mobileScreenSize;

              // Open the upsell overlay (if submitted from quick add drawer)
              if (this.upsellOverlay && isMobile) {
                if (quickAddDrawer) {

                  // sets up time/date functionality + populates some drawer content
                  const upsellEvent = new CustomEvent('open-upsell-drawer');
                  document.dispatchEvent(upsellEvent);

                  //close quick add drawer
                  quickAddDrawer.close();

                  // make sure overlay is set up properly
                  // this.overlay.classList.add('is-visible');
                  // this.scrollY = window.scrollY;
                  // document.body.classList.add("fixed");
                  // document.body.style.top = `-${this.scrollY}px`;
                  // document.documentElement.style.height = "100vh";

                      // Prevent page behind from scrolling when side drawer is open.
                      document.documentElement.style.scrollBehavior = "";

                      this.scrollY = window.scrollY;

                      document.documentElement.style.height = "100vh";
                      document.body.style.top = `-${this.scrollY}px`;

                  // updates cart drawer contents
                  this.cartDrawer.renderContents(
                    data, false
                  );

                } else {
                  // Open the upsell overlay (when no quick add drawer)

                  // sets up time/date functionality + populates some drawer content
                  const upsellEvent = new CustomEvent('open-upsell-drawer');
                  document.dispatchEvent(upsellEvent);

                  if(isMobile) {
                    // updates cart drawer contents
                    this.cartDrawer.renderContents(
                      data, false
                    )
                  } 
                  
                }
              } else if (this.upsellOverlay && !isMobile) {
                this.cartDrawer.renderContents(
                  data, theme.settings.afterAtc === 'drawer'
               );
              }

              if (!this.upsellOverlay) {
                this.cartDrawer.renderContents(
                  data, theme.settings.afterAtc === 'drawer'
               );
              }

            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 50);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        
        if (this.upsellOverlay) {
          const isTriggeredFromOverlay = evt.srcElement.closest('.upsell');
          console.log('isTriggeredFromOverlay', isTriggeredFromOverlay);
          if (isTriggeredFromOverlay) {
            this.upsellAnimate(evt);
          };
        }

        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 50);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) this.errorMsg.textContent = error;
    }

    upsellAnimate(evt) {

      // evt.preventDefault();
      const srcEl = evt.srcElement;

      console.log('srcEl', srcEl);
  
      // Get the elements
      const button = srcEl.querySelector('button[type="submit"]');
      console.log('button', button);

      const addToCartText = button.querySelector('.upsell__add-to-cart-text');
      const confirmationText = button.querySelector('.upsell__added-confirmation');
  
      if (addToCartText && confirmationText) {
        // Slide up the add to cart text
        addToCartText.style.transform = "translateY(-200%)";
  
        // Slide down the confirmation text
        confirmationText.style.transform = "translateY(-50%)";
        confirmationText.style.top = "50%";
  
        // After 2 seconds, revert the changes
        setTimeout(() => {
          addToCartText.style.transform = "translateY(-50%)";
          confirmationText.style.transform = "translateY(200%)";
        }, 2000);
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
